import React, { useEffect, useRef, useState } from 'react';
import '../../styles/Navbar.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext.tsx';
import { GiHamburgerMenu, GiAmericanFootballHelmet, GiCardAceSpades, GiWhistle } from "react-icons/gi";
import { FaUserAlt } from "react-icons/fa";
import { logUserActivity } from '../../services/player/LoginService.tsx';
import { IoIosArrowDown } from "react-icons/io";
import { IoSettingsOutline, IoDocumentTextOutline, IoChevronForward } from "react-icons/io5";
import { RiLogoutCircleLine } from "react-icons/ri";
import { FaRegEnvelope } from "react-icons/fa6";
import { GoSearch } from "react-icons/go";
import { AiOutlineHome } from "react-icons/ai";
import { useUnreadMessages } from '../../hooks/useUnreadMessages.ts';
import { TbList } from "react-icons/tb";
import { MdArrowForwardIos, MdOutlineContactMail } from "react-icons/md";
import { useSport } from '../../context/SportContext.tsx';
import AlertError from '.././alerts/AlertError.tsx';
import { formatNumbers, isFreePlayBet, isPropsBet } from '../../helpers/functions.tsx';
import { applyLoginChrome } from '../../helpers/loginChrome.ts';
import { usePlayerMyBets } from '../../hooks/usePlayerMyBets.ts';
import { useBetContext } from '../../context/BetContext.tsx';
import { useBetContext as useParlayBetContext } from '../../context/ParlayBetContext.tsx';
import { useModal } from '../../context/ModalContext.tsx';
import StraightBets from './modals/strainght/StraightBets.tsx';
import OneBet from './modals/strainght/strainghtResponsive/OneBet.tsx';
import PropsBetSlip from './modals/props/PropsBetSlip.tsx';
import { useIsSmallScreen } from './SportsSchedule.tsx';
import { scrollPageToTop } from '../../helpers/scrollPageToTop.ts';
import { canAccessVimplayGames } from '../../services/player/VimplayService.tsx';

// function useIsMobile(breakpoint = 768) {
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);

//   useEffect(() => {
//     const handleResize = () => setIsMobile(window.innerWidth <= breakpoint);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, [breakpoint]);

//   return isMobile;
// }

/**
 * Represents the navigation bar of the website.
 */

interface NavbarProps {
  setShowFooter?: any;
}

function Navbar({ setShowFooter }: NavbarProps) {

  const navigate = useNavigate();
  const { user, logout, userIpData } = useUser();
  const { bets: myBets } = usePlayerMyBets();
  if (!user?.userName) {
    throw new Error("User not authenticated");
  }
  const { setShowSports, setSelectedGames, setShowHomeButton, setCheckedLeagues, setActiveGames,
    setCommercialGames, setShowOptions, setActiveFutureGames, setGameEspecial, showSports } = useSport();;
  const [menuOpen, setMenuOpen] = useState(false);
  const [leftmenu, setleftMenu] = useState(false);
  const [selected, setSelected] = useState("");
  // const isMobile = useIsMobile();
  // const route = isMobile ? "/bets/figures" : "/bets/calendar/month";
  const [isOpen, setIsOpen] = useState(false);
  const navRef = useRef<HTMLDivElement>(null);
  const searchRef = useRef<HTMLDivElement>(null);
  const [searchTerm, setSearchTerm] = useState("");
  const location = useLocation();
  const [errorMessage, setErrorMessage] = useState('');
  const { bets, clearBets, setUseFreePlay } = useBetContext();
  const {
    deleteAllBets,
    setTeaserPoints,
    setTeaserType,
    setTeaserFixture,
    setErrorMessageBets,
  } = useParlayBetContext();
  const totalBets = bets.length;
  const { showModal, closeModal } = useModal();
  const isSmallScreen = useIsSmallScreen();
  const onSportsMenuSmall =
    isSmallScreen &&
    showSports &&
    (location.pathname === "/home" || location.pathname === "/home/parlay");
  const { unreadCount, showNewMessageToast, dismissToast } = useUnreadMessages(user?.userName);

  /** Close bet modals and clear straight/props/parlay/teaser selections. */
  const clearOpenBetsAndModals = () => {
    clearBets();
    setUseFreePlay(false);
    deleteAllBets();
    setTeaserPoints(0);
    setTeaserType(null);
    setTeaserFixture('');
    setErrorMessageBets('');
    closeModal();
  };

  useEffect(() => {
    if (!onSportsMenuSmall) return;
    clearOpenBetsAndModals();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onSportsMenuSmall]);

  const openPicksModal = () => {
    if (window.innerWidth < 1300) {
      const isProps = bets.some(bet => isPropsBet(bet));
      if (isProps) {
        showModal(
          <PropsBetSlip setErrorMessage={setErrorMessage} />
        );
        return;
      }

      showModal(
        bets.length > 1 ? (
          <StraightBets setErrorMessage={setErrorMessage} />
        ) : (
          <OneBet setErrorMessage={setErrorMessage} />
        )
      );
      return;
    }

    showModal(
      <StraightBets setErrorMessage={setErrorMessage} />
    );
  };

  const totalbets = myBets.length;
  const totalPendingAmount = myBets.reduce((total, bet) => {
    if (isFreePlayBet(bet)) return total;
    return total + (bet.bet || 0);
  }, 0);

  const toggleMenu = () => {
    setMenuOpen((prev) => {
      if (!prev) setleftMenu(false);
      return !prev;
    });
  };

  const toggleLeftMenu = () => {
    setleftMenu((prev) => {
      if (!prev) setMenuOpen(false);
      return !prev;
    });
  };

  const handleLogout = async () => {
    // Force dark login chrome BEFORE tearing down the player shell (Safari top bar).
    applyLoginChrome();
    clearOpenBetsAndModals();
    await logout();
    navigate('/');
  };


  const handleLogoClick = (e?: React.MouseEvent) => {
    e?.preventDefault();

    resetHomeState();
    setShowHomeButton(false);
    setSelected("");

    if (window.location.pathname === "/home") {
      navigate("/home", { replace: true });
    } else {
      navigate("/home");
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      window.history.pushState({ modalOpen: true }, '');
    }

    const handlePopState = () => {
      if (isOpen) {
        setIsOpen(false);
      }
    };

    window.addEventListener('popstate', handlePopState);
    return () => {
      document.body.style.overflow = 'auto';
      window.removeEventListener('popstate', handlePopState);
    };
  }, [isOpen]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        navRef.current &&
        !navRef.current.contains(event.target as Node) &&
        searchRef.current &&
        !searchRef.current.contains(event.target as Node)
      ) {
        setSelected("");
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  useEffect(() => {
    if (location.pathname !== "/home") {
      setSelected("");
    }
  }, [location.pathname]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 999) {
        setSelected("");
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // const searchPaths = ["/home", "/home/parlay", "/home/teaser"];
  // const isSearchPage = searchPaths.includes(location.pathname) && location.pathname !== "/home/teaser";

  const resetHomeState = () => {
    clearOpenBetsAndModals();
    setShowFooter?.(true);
    setShowSports?.(true);
    setSelectedGames?.(false);

    setCheckedLeagues?.({});
    setActiveGames?.([]);
    setGameEspecial?.([]);
    setCommercialGames?.([]);
    setActiveFutureGames?.([]);
    setShowOptions?.([]);

    // Same-route HOME does not remount; reset every scroll container after the menu paints.
    scrollPageToTop();
    requestAnimationFrame(() => scrollPageToTop());
  };

  const goHomeWithSetup = () => {
    resetHomeState();
    navigate("/home");
  };

  const handleContinueClick = () => {
    resetHomeState();
    setShowHomeButton(false);
    navigate('/home');
  };

  return (
    <>
      {bets.length !== 0 && !onSportsMenuSmall && (
        <div className='containerButtonParlay'>
          <button className='btn-custom' onClick={openPicksModal}>{totalBets} Pick(s)</button>
        </div>
      )}
      <nav className="background main-menu">
        <div className='d-flex align-items-center justify-content-between'>
          <Link to="/home" onClick={handleLogoClick}>
            <img className="logo navbar-media" src={require("../../images/logo.png")} alt="company logo" />
          </Link>
          <div className="hamburger-circle show-navbar" onClick={toggleLeftMenu}>
            <div className="hamburger-lines"></div>
          </div>
          <div className="icon-container-navbar show-navbar">
            <div ref={navRef}
              // onClick={(e) => {
              //   e.stopPropagation();
              //   if (showHomeButton) {
              //     setSelected("home");
              //     goHomeWithSetup();
              //     setShowHomeButton(false);
              //   } else {
              //     if (isSearchPage) {
              //       setSelected(prev => (prev === "search" ? "" : "search"));
              //     } else {
              //       setSelected("home");
              //       goHomeWithSetup();
              //     }
              //   }
              // }}
              onClick={(e) => {
                e.stopPropagation();

                setSelected("home");
                goHomeWithSetup();
                setShowHomeButton(false);
              }}
              className="d-flex flex-column align-items-center cursor-pointer">
              <AiOutlineHome className="icon-navbar" />
              <span className="name-icon teko">HOME</span>
              {/* {showHomeButton ? (
                <>
                  <AiOutlineHome className="icon-navbar" />
                  <span className="name-icon teko">HOME</span>
                </>
              ) : (
                <>
                  {isSearchPage ? (
                    <GoSearch className="icon-navbar" />
                  ) : (
                    <AiOutlineHome className="icon-navbar" />
                  )}
                  <span className="name-icon teko">
                    {isSearchPage ? "SEARCH" : "HOME"}
                  </span>
                </>
              )} */}
            </div>
          </div>

          <div className="d-flex align-items-center">
            <span className="userName navbar-media"><FaUserAlt className="logouserName" />{user?.userName}</span>
            <Link to="/bets/figures" className="balance navbar-media">
              <span className="size-balance">
                BALANCE:{" "}
                <span className={user?.balance >= 0 ? "positive-balance" : "negative"}>
                  ${formatNumbers(user?.balance || 0)}
                </span>
              </span>
            </Link>
            <div className='balance-container show-navbar'>
              <Link to="/bets/figures" className="balance-media">
                <span className={
                  user?.balance >= 0 ? "positive-balance balance-size-navbar" : "negative balance-size-navbar"}>
                  $ {formatNumbers(user?.balance || 0)}
                </span>
                <span className="size-balance">BALANCE</span>
              </Link>
            </div>
            <div onClick={toggleMenu} className='menu-icons'>
              <GiHamburgerMenu className='burger-line navbar-media' />
              <IoIosArrowDown className='burger-line show-navbar' />
            </div>
          </div>
        </div>


        <ul className={`left-menu left ${leftmenu ? "open" : ""}`} onClick={toggleLeftMenu}>
          <div className="home-menu" onClick={(e) => e.stopPropagation()}>
            <span className="home-menu__caret" aria-hidden="true" />
            <div className="home-menu__grid">
              <div className="home-menu__card" onClick={() => { handleContinueClick(); toggleLeftMenu(); }}>
                <span className="home-menu__body">
                  <GiAmericanFootballHelmet className="home-menu__icon" />
                  <span className="home-menu__label">Sports Betting</span>
                </span>
                <IoChevronForward className="home-menu__chevron" />
              </div>
              <Link to="/propsLeagues" className="home-menu__card"
                onClick={(e) => {
                  logUserActivity(user.userName, "Prop Betting", userIpData);
                  if (user?.status !== "Active") {
                    e.preventDefault();
                    setErrorMessage("Your account is in read-only mode.");
                    return;
                  }
                  toggleLeftMenu();
                }}>
                <span className="home-menu__body">
                  <TbList className="home-menu__icon" />
                  <span className="home-menu__label">Prop Betting, Build SGP</span>
                </span>
                <IoChevronForward className="home-menu__chevron" />
              </Link>
              <Link to="/commercialLive" className="home-menu__card"
                onClick={(e) => {
                  logUserActivity(user.userName, "PropLive", userIpData);
                  if (user?.status !== "Active") {
                    e.preventDefault();
                    setErrorMessage("Your account is in read-only mode.");
                    return;
                  }
                  toggleLeftMenu();
                }}>
                <span className="home-menu__body">
                  <svg className="home-menu__live" viewBox="0 0 36 28" aria-hidden="true">
                    <rect x="1.75" y="1.75" width="32.5" height="19" rx="2.2" fill="none" stroke="currentColor" strokeWidth="2" />
                    <path d="M13 25.2h10M18 20.8v4.4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    <text x="18" y="14.2" textAnchor="middle" fontSize="7.2" fontWeight="800" fill="currentColor">LIVE</text>
                  </svg>
                  <span className="home-menu__label">Live Betting</span>
                </span>
                <IoChevronForward className="home-menu__chevron" />
              </Link>
              {canAccessVimplayGames(user) && (
                <Link to="/vimplay" className="home-menu__card" onClick={() => {
                  logUserActivity(user.userName, "View Games", userIpData);
                  toggleLeftMenu();
                }}>
                  <span className="home-menu__body">
                    <GiCardAceSpades className="home-menu__icon" />
                    <span className="home-menu__label">Casino</span>
                  </span>
                  <IoChevronForward className="home-menu__chevron" />
                </Link>
              )}
              <Link to="/rulesBox" className="home-menu__card" onClick={() => {
                logUserActivity(user.userName, "View Rules Box", userIpData);
                toggleLeftMenu();
              }}>
                <span className="home-menu__body">
                  <IoDocumentTextOutline className="home-menu__icon" />
                  <span className="home-menu__label">Rules</span>
                </span>
                <IoChevronForward className="home-menu__chevron" />
              </Link>
              <div className="home-menu__card home-menu__card--soon" aria-disabled="true">
                <span className="home-menu__body">
                  <MdOutlineContactMail className="home-menu__icon" />
                  <span className="home-menu__label">Coming Soon</span>
                </span>
              </div>
            </div>
          </div>
        </ul>

        <ul className={`navbar-menu ${menuOpen ? 'open' : ''}`} onClick={toggleMenu}>
          <div className='close-button navbar-media'>
            <MdArrowForwardIos className='arrow-close' />
          </div>
          <div className='containeruser'>
            <FaUserAlt className="logouser navbar-media" />
            <IoSettingsOutline className='setting-navbar show-navbar' data-bs-toggle="modal" data-bs-target="#staticBackdrop" />
            <h4 className='user teko'>{user?.userName}</h4>
          </div>
          <div className='containerInfo'>
            <span className='lineNavbar show-navbar'></span>
            <Link to="/bets/figures" className='container container-navbar show-navbar'>
              <span className='teko avaliable-navbar'>${formatNumbers(user?.balance)}</span>
              <span className='font-navbar'>Balance</span>
            </Link>
            <span className='lineNavbar show-navbar'></span>
            <Link to="/bets" className='container container-navbar show-navbar'>
              <span className='teko pending-navbar'>${formatNumbers(totalPendingAmount)}</span>
              <span className='font-navbar'>Pending</span>
            </Link>
            <span className='lineNavbar show-navbar'></span>
            <div className='container container-navbar show-navbar'>
              <span className='teko avaliable-navbar'>${formatNumbers(user.available)}</span>
              <span className='font-navbar'>Available</span>
            </div>
            <span className='lineNavbar show-navbar'></span>



            <div className='container container-navbar navbar-media'>
              <span className='teko avaliable-navbar'>${formatNumbers(user.available)}</span>
              <span className='font-navbar'>Available</span>
            </div>
            <div className='container container-navbar'>
              <span className='teko balance-navbar '>${formatNumbers(user?.freePlay)}</span>
              <span className='font-navbar'>Free Play</span>
            </div>
            <div className='container container-navbar navbar-media'>
              <span className='teko pending-navbar'>${formatNumbers(totalPendingAmount)}</span>
              <span className='font-navbar'>Pending</span>
            </div>
          </div>

          <div className='containerButton'>
            <span className='lineNavbar line-none mt-3 navbar-media'></span>
            <Link to="/bets" className='buttonNavegation teko bets-container navbar-media'>My Bets  <div className="bets-badge ">
              {totalbets}
            </div></Link>
            <span className='lineNavbar navbar-media'></span>
            <Link to="/bets/update" className='buttonNavegation teko navbar-media'>Notifications</Link>
            <span className='lineNavbar navbar-media'></span>
            <span data-bs-toggle="modal" data-bs-target="#staticBackdrop" className='buttonNavegation teko navbar-media'>Account</span>
            <span className='lineNavbar'></span>

            <Link to="/messaging" className='buttonNavegation teko text-aling-messagin navbar-media messages-container' onClick={() => logUserActivity(user.userName, "View Messages", userIpData)}>
              Messages
              {unreadCount > 0 && <div className="messages-badge">{unreadCount > 99 ? '99+' : unreadCount}</div>}
            </Link>
            <div className="messaging-media show-navbar">
              <FaRegEnvelope className="messagin-left" />
              <Link to="/messaging" className='buttonNavegation teko float-right messages-container' onClick={() => logUserActivity(user.userName, "View Messages", userIpData)}>
                Messages
                {unreadCount > 0 && <div className="messages-badge">{unreadCount > 99 ? '99+' : unreadCount}</div>}
              </Link>
            </div>
            <span className='lineNavbar navbar-media'></span>
            <span className='lineNavbar show-navbar'></span>

            <Link to="/rulesBox" className='buttonNavegation teko text-aling-messagin navbar-media' onClick={() => logUserActivity(user.userName, "View Rules Box", userIpData)}>
              Rules Box
            </Link>
            <div className="rules-box-media show-navbar">
              <GiWhistle className="rules-box-left" />
              <Link to="/rulesBox" className='buttonNavegation teko float-right' onClick={() => logUserActivity(user.userName, "View Rules Box", userIpData)}>
                Rules Box
              </Link>
            </div>
            <span className='lineNavbar navbar-media'></span>
            <span className='lineNavbar show-navbar'></span>
            {/* <Link to="/FAQ" className='buttonNavegation teko navbar-media' onClick={() => logUserActivity(user.userName, "View FAQ", userIpData)}>F.A.Q</Link>
            <span className='lineNavbar'></span> */}
            <span onClick={handleLogout} className='buttonNavegation teko navbar-media'>Sign out</span>
            <div className="logout-wrapper show-navbar" onClick={handleLogout}>
              <RiLogoutCircleLine className="float-left" />
              <span className='buttonNavegation teko float-right'>Sign out</span>
            </div>
          </div>
        </ul>
      </nav>

      {selected === "search" && (
        <div ref={searchRef} className="search-bar-container">
          <div className="search-input-wrapper">
            <GoSearch className="search-icon" />
            <input
              type="text"
              className="search-input"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {searchTerm && <button className="search-btn">GO</button>}
          </div>
        </div>
      )}

      <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex={-1} aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div className="modal-dialog spacing-modal">
          <div className="modal-content content-modal-spacin">
            <div className="modal-title-acount">
              <span className="font-account teko">My Account</span>
            </div>
            <div className="container-account">
              <div className='balance-user'>
                <span className='teko'>Balance</span>
                <span className='teko'>$ {formatNumbers(user?.balance)}</span>
              </div>
              <div className='balance-user'>
                <span className='teko'>Pending</span>
                <span className='teko'>$ {formatNumbers(totalPendingAmount)}</span>
              </div>
              <div className='balance-user'>
                <span className='teko'>Avaliable</span>
                <span className='teko'>$ {formatNumbers(user?.available)}</span>
              </div>
              <div className='balance-user'>
                <span className='teko'>Credit Limit</span>
                <span className='teko'>$ {formatNumbers(user?.creditLimit)}</span>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-danger btn-sm" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="modal fade" id="liveresult" tabIndex={-1}>
        <div className="modal-dialog modal-xl modal-dialog-centered dialog-modal">
          <div className="modal-content content-modal">
            <div className="header-scoreboard">
              <div className="title-scoreBoard">ScoreBoard</div>
              <div className="close" data-bs-dismiss="modal">Close</div>
            </div>
            <LiveResults />
          </div>
        </div>
      </div> */}

      {
        errorMessage && (
          <AlertError
            message={errorMessage}
            onClose={() => setErrorMessage("")}
          />
        )
      }

      {showNewMessageToast && (
        <div className="message-toast-bubble" onClick={dismissToast}>
          <FaRegEnvelope className="message-toast-icon" />
          <div className="message-toast-content">
            <span className="message-toast-title">New message</span>
            <span className="message-toast-text">You have {unreadCount} unread message{unreadCount !== 1 ? 's' : ''}</span>
          </div>
          <Link to="/messaging" className="message-toast-link" onClick={() => { dismissToast(); logUserActivity(user.userName, "View Messages", userIpData); }}>
            View
          </Link>
        </div>
      )}

    </>
  );
};

export default Navbar;
